import { RoleCode } from 'hooks/useGetRoles';

export type RoleKey =
  | 'admin'
  | 'moderator'
  | 'agent'
  | 'developer'
  | 'franchiseOwner';

export const USER_ROLE: Record<RoleKey, RoleCode> = {
  admin: 'admin',
  moderator: 'moderator',
  agent: 'agent',
  developer: 'developer_vendor',
  franchiseOwner: 'franchise_owner',
};
